import ErrorsPage from './ErrorsPage';

export default ErrorsPage;
